import TransferDealToEnterpriseColleagueModal from './TransferDealToEnterpriseColleagueModal.component';

export default TransferDealToEnterpriseColleagueModal;
